import { IframeMessageProxy as IMP } from 'iframe-message-proxy';
import IMPConstants from '../constants/iframe-message-proxy-container';

const BASE_URI = '/contacts';
const REQUEST_TYPE = 'application/vnd.lime.contact+json';

const getContact = async (identity) => {
    try {
        const { response } = await IMP.sendMessage({
            action: IMPConstants.Actions.SEND_COMMAND,
            content: {
                destination: IMPConstants.Destinations.MESSAGING_HUB_SERVICE,
                command: {
                    method: IMPConstants.CommandMethods.GET,
                    uri: `${BASE_URI}/${encodeURIComponent(identity)}`
                }
            }
        });
        return response;
    } catch {
        return {};
    }
};

const setContact = async (identity, data) => {
    try {
        const dataValues = !data?.identity ? { ...data, identity } : data;

        await IMP.sendMessage({
            action: IMPConstants.Actions.SEND_COMMAND,
            content: {
                destination: IMPConstants.Destinations.MESSAGING_HUB_SERVICE,
                command: {
                    method: IMPConstants.CommandMethods.SET,
                    uri: `${BASE_URI}/${encodeURIComponent(identity)}`,
                    type: REQUEST_TYPE,
                    resource: dataValues
                }
            }
        });
        return true;
    } catch {
        return false;
    }
};

const resetContact = async ({ identity, source }) => {
    await setContact(identity, { identity, source, extras: {} });
};

export { getContact, setContact, resetContact };
